var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"image-content\">\n    <img class=\"store\" src=\""
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"original") : depth0), depth0))
    + "\">\n</div>\n<div>\n    <div class=\"action-bar\">\n        <div class=\"pull-left\">\n            <button class=\"btn btn-default cancel\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Action.Close",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":7,"column":51},"end":{"line":7,"column":74}}}))
    + "</button>\n        </div>\n    </div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/stores-image.hbs
// module id = iRsf
// module chunks = 1